import { imageModifierTypes } from '../constants';
import modifyImageLink from './modifyImageLink';
import userImagePlaceholder from '../../static/images/user-placeholder.svg';

const getUserLogoUrl = (imageUrl, modificationType = imageModifierTypes.LOGO) =>
  imageUrl ? modifyImageLink(imageUrl, modificationType) : userImagePlaceholder;

export default getUserLogoUrl;

